module.exports = __webpack_public_path__ + "media/images/dropdown-arrow-e7ffd79ca0abef326fcbd3213294f149.svg";